
export function ProgressBar({ progressColor, completionPercentage }: { progressColor: string; completionPercentage: number; }) {
    return (
        <div className="flex flex-row justify-between items-center">
            <div className={`w-full border-2 rounded-lg bg-white dark:bg-stone-400 h-2 mr-2`}>
                <div className={`h-full ${progressColor}`} style={{ width: `${completionPercentage}%` }} />
            </div>
            <p className="text-center text-sm dark:text-stone-300">{completionPercentage}%</p>
        </div>
    );
}
